import React, { useEffect } from 'react'
import styled from 'styled-components'

export default function SdkPage() {
  const publicBaseUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '')

  useEffect(() => {
    let detectorInstance = null
    let warningUiInstance = null
    let isUnmounted = false

    const startDetector = async () => {
      try {
        const { MonitorDogOfflineDetector } = window.MonitorDogOfflineDetector
        warningUiInstance = window.MonitorDogWarningUI.create({
          mode: 'toast',
          title: '휴대폰이 감지되었습니다',
          message: '카메라 화면에서 휴대폰을 치운 뒤 검사를 계속해 주세요.',
        })

        detectorInstance = await MonitorDogOfflineDetector.init({
          runtimeAssetBaseUrl: `${publicBaseUrl}/vendor/monitordog-offline/assets`,
          onDetect: (result) => {
            if (!isUnmounted) {
              warningUiInstance?.setVisible(result.phoneCount > 0)
            }
          },
          onError: (error) => {
            console.error(error.code ?? 'OFFLINE_DETECTOR_ERROR', error)
          },
        })

        // init 도중 다른 페이지로 이동했을 수 있음
        if (isUnmounted) {
          detectorInstance.dispose()
          return
        }

        await detectorInstance.start()
      } catch (error) {
        if (!isUnmounted) {
          console.error(error.code ?? 'RUNTIME_START_FAILED', error)
        }
      }
    }

    startDetector()

    // SDK 페이지에서 나갈 때 detector와 경고 UI를 함께 정리한다.
    return () => {
      isUnmounted = true
      detectorInstance?.dispose()
      warningUiInstance?.dispose()
    }
  }, [publicBaseUrl])

  return <Page />
}

const Page = styled.main`
  min-height: 100vh;
`
